import { Chip, Typography } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { useGetInvoiceByIdQuery } from "src/api/services/invoicesApi";
import { stripeStatusMap } from "src/utils/stripeStatusMap";

interface Props {
  invoiceId?: string | null;
}

const InvoiceStatusChip = ({ invoiceId }: Props) => {
  const { data } = useGetInvoiceByIdQuery(
    invoiceId != null ? invoiceId : skipToken,
  );

  if (data == null) {
    return null;
  }

  return (
    <Chip
      color={stripeStatusMap[data.status].color}
      label={<Typography>{`${stripeStatusMap[data.status].text}`}</Typography>}
    />
  );
};

export default InvoiceStatusChip;
